import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues {
    getSelectableStoreLocations {
      data {
        id: guid
        description: name
      }
      recordCount
    }
  }
`;

export const useGetStoreLocationsAsOptionsQuery = () => {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
};

